"use strict";
exports.__esModule = true;
var lib_1 = require("kaizen-ui-colors/lib");
var chartDefaultOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.5,
    elements: {
        point: {
            radius: 0,
            hitRadius: 6,
            backgroundColor: '#fff'
        }
    },
    legend: {
        position: 'bottom',
        labels: {
            fontFamily: '"Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontColor: lib_1.colors.slate__4c566c,
            boxWidth: 20,
            padding: 20,
            usePointStyle: true
        }
    },
    scales: {
        xAxes: [
            {
                gridLines: {
                    display: false
                },
                ticks: {
                    autoSkipPadding: 8
                }
            },
        ],
        yAxes: [
            {
                gridLines: {
                    color: lib_1.colors.mochi_lighter__f9fafd,
                    drawBorder: false,
                    tickMarkLength: 20
                },
                ticks: {
                    beginAtZero: true
                }
            },
        ]
    },
    tooltips: {
        enabled: false,
        intersect: false
    },
    hover: {
        intersect: false
    },
    layout: {
        padding: {
            top: 24,
            right: 24,
            left: 24
        }
    }
};
exports["default"] = chartDefaultOptions;
